import { Component, NgZone } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from '../environments/environment';
import { akitaDevtools } from '@datorama/akita';
import { SessionService } from './services/session/session.service';
import { SessionQuery } from './services/session/session.query';
import { AccountQuery, AccountService } from '@core/state/account';
import { is } from 'bluebird';
import { Capacitor } from '@capacitor/core';

@Component({
  selector   : 'app-root',
  templateUrl: 'app.component.html',
  styleUrls  : ['app.component.scss']
})
export class AppComponent {
  public isLoggedIn$;
  // public account$;
  // public isSingle = false;
  public menuClosed = true;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private ngZone: NgZone,
    private sessionService: SessionService,
    private sessionQuery: SessionQuery,
    private accountQuery: AccountQuery,
    private accountService: AccountService,
  ) {
    this.isLoggedIn$ = sessionQuery.isLoggedIn$;
    /* this.account$ = accountQuery.select().subscribe((acc) => {
      if (acc && (acc.marital_status == null || acc.marital_status.name == 'Alleenstaand')) {
        this.isSingle = true;
      }else {
        this.isSingle = false;
      }
    }); */

    /* accountService.get().subscribe(d => {
      console.log(d);
    }); */

    if (!environment.production) {
      akitaDevtools(ngZone);
    }
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (Capacitor.platform = 'android'){
       this.statusBar.styleLightContent; 
      }
      else {
        this.statusBar.styleDefault();
      }
      
      this.splashScreen.hide();
    });
  }

  logout() {
    this.sessionService.logout();
  }

  onMenuClose() {
    this.menuClosed = true;
  }

  onMenuOpen() {
    this.menuClosed = false;
  }
}
